import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-landing-aceptacion-aliado',
  templateUrl: './landing-aceptacion-aliado.component.html',
  styleUrls: ['./landing-aceptacion-aliado.component.scss'],
  standalone: false,
})
export class LandingAceptacionAliadoComponent {
  constructor(private readonly router: Router) {}

  goToLogin(): void {
    this.router.navigateByUrl('/intermediario/login');
  }
}
